import React from 'react';

function Minus(props) {
    const fill = props.fill;
    const className = props.className;
    return (
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width="20" 
            height="18" 
            viewBox="0 0 20 18" 
            fill="none"
            className={className}
        >
            <path 
                d="M3.00807 10.61C2.69342 10.61 2.4417 10.52 2.25291 10.34C2.06412 10.16 1.96973 9.92 1.96973 9.62V8.99C1.96973 8.69 2.06412 8.45 2.25291 8.27C2.4417 8.09 2.69342 8 3.00807 8H16.9314C17.246 8 17.4978 8.09 17.6865 8.27C17.8753 8.45 17.9697 8.69 17.9697 8.99V9.62C17.9697 9.92 17.8753 10.16 17.6865 10.34C17.4978 10.52 17.246 10.61 16.9314 10.61H3.00807Z"
                fill={fill}
            />
        </svg>
    )
};

export default Minus;